<template>
  <div class="track">
    <span class="track-detail">{{ track.tracknum }}</span>
    <span class="track-detail">{{ track.title }}</span>
    <span class="track-detail">{{ track.length }}</span>
    <span class="track-detail">{{ track.isrc }}</span>
  </div>
</template>

<script>
export default {
  name: "AlbumTrack",

  props: {
    track: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.track {
  font-size: 0.8em;
  text-align: left;
  padding: 5px 10px;
  border: 1px solid #cccccc;
  border-top: none;
  display: flex;
  align-items: center;

  .track-detail {
    width: 70px;
    text-align: left;

    &:first-child {
      width: 40px;
    }

    &:nth-child(2) {
      width: 240px;
    }

    &:last-child {
      width: 110px;
    }
  }

  &:nth-of-type(2n) {
    background-color: rgba(#cccccc, 0.15);
  }
}
</style>
